import {$qsAll} from '../../../../@shared/ts/dom';
import {type LoadingMode} from '../../models/IEnvironment';
import {DefaultCart} from '../../reducers/cartReducer';
import {Environment} from '../../reducers/environmentReducer';
import {PaymentConfiguration} from '../../reducers/paymentConfigurationReducer';
import {store} from '../../store';
import {type PayPalGateway} from './paypal';

function setupPayPalButtonRendering(gateways: Record<string, PayPalGateway>) {
	store.subscribe(() => {
		renderPayPalDisplayState(
			PaymentConfiguration.selectedGateway(),
			Environment.modalUI.loadingMode(),
		);

		controlPayPalButtonMounts(gateways);
	});
}

/**
 * Renders the paypal button loading state.
 */
function renderPayPalDisplayState(gatewayId: string, mode: LoadingMode) {
	// Enable/Disable button
	if (gatewayId.startsWith('peachpay_paypal_') && mode === 'finished' && DefaultCart.contents().length > 0) {
		$qsAll('.paypal-btn-container', $element => {
			$element.classList.remove('hide');
		});
		$qsAll('.paypal-spinner-container', $element => {
			$element.classList.add('hide');
		});
	} else if (gatewayId.startsWith('peachpay_paypal_') && DefaultCart.contents().length > 0) {
		$qsAll('.paypal-btn-container', $element => {
			$element.classList.add('hide');
		});
		$qsAll('.paypal-spinner-container', $element => {
			$element.classList.remove('hide');
		});
	} else {
		$qsAll('.paypal-btn-container', $element => {
			$element.classList.add('hide');
		});
		$qsAll('.paypal-spinner-container', $element => {
			$element.classList.add('hide');
		});
	}
}

function controlPayPalButtonMounts(gateways: Record<string, PayPalGateway>) {
	if (!PaymentConfiguration.selectedGateway().startsWith('peachpay_paypal_')) {
		return;
	}

	// Sorting the methods makes sure the last active method is always detached before the new method is
	// attached because they may share some containers.
	for (const [_, gateway] of Object.entries(gateways).sort(([_, m1], [__, m2]) => (m2.state?.mountTarget?.length ?? 0) - (m1.state?.mountTarget.length ?? 0))) {
		if (!gateway.state) {
			gateway.state = {
				mountTarget: '',
			};
		}

		const newMountTarget = customButtonMountTarget();
		if (gateway.state.mountTarget && gateway.state.mountTarget !== newMountTarget) {
			gateway?.detach?.();
			gateway.state.mountTarget = '';
		}

		if (PaymentConfiguration.selectedGateway() === gateway.config.gatewayId) {
			if (gateway.state.mountTarget) {
				continue;
			}

			gateway?.attach?.(newMountTarget);

			gateway.state.mountTarget = newMountTarget;
		} else {
			if (!gateway.state.mountTarget) {
				continue;
			}

			gateway?.detach?.();

			gateway.state.mountTarget = '';
		}
	}
}

function customButtonMountTarget(): string {
	if (Environment.customer.mobile()) {
		return '#mobile-customer-pay-button .paypal-btn-container';
	}

	return '#new-customer-pay-button .paypal-btn-container';
}

export {
	setupPayPalButtonRendering,
};
